import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38e7bb98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col" }
const _hoisted_2 = { class: "mb-8 font-space text-medium font-bold text-xl" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Are you familiar with Rare Earth Elements? ")
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "flex-row"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" YES ")
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" NO ")
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "md:w-1/3 mt-16" }
const _hoisted_11 = {
  key: 0,
  class: "h-28"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": _ctx.answer === null,
      "wrapper-classes": "flex flex-col"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_2, _hoisted_4)), [
          [_directive_t, 'step2.title']
        ]),
        (_ctx.answer === null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "px-8 orange-button mr-8",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAnswer(true)))
              }, _hoisted_7)), [
                [_directive_t, 'buttons.yes']
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "px-8 orange-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAnswer(false)))
              }, _hoisted_9)), [
                [_directive_t, 'buttons.no']
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.answer === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.answer === true)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 1,
                class: "w-card max-w-full",
                title: _ctx.$t('Great!')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "text-lg text-justify",
                    innerHTML: _ctx.$t('step2.okcard')
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.answer === false)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 2,
                class: "magnet-rb w-card max-w-full"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "text-lg text-justify mb-4",
                    innerHTML: _ctx.$t('step2.nokcard')
                  }, null, 8, _hoisted_13)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.answer !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: _ctx.$t('step2.continue'),
              class: "text-bold text-lg text-center text-pxorange font-space italic mt-auto mb-16"
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen", "hide-arrow"])
  ]))
}